import { mainAxios } from "../mainAxios";
import { getDefaultHeaders, getErrorMessage } from "./mainService";

export const addTelefonoToListaNegra = async ({ telefono, emisionId, solicitudId, origen }) => {
  try {
    const body = {
        telefono, origen,
        ...(!!emisionId && { emision_id: emisionId }),
        ...(!!solicitudId && { solicitud_id: solicitudId }),
    }
    const response = await mainAxios.post(
      `/v1/telefonoListaNegra`,
      body,
      getDefaultHeaders()
    );

    return response.data.data;
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};

export const validarExistenciaTelefonoEnListaNegra = async (telefono) => {
  try {
    const response = await mainAxios.get(
      `/v1/telefonoListaNegra/exists?telefono=${telefono}`,
      getDefaultHeaders()
    );

    return response.data.data.existe; // TRUE OR FALSE
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};
